import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { isEqual } from "lodash";
import { map } from "rxjs/operators";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class ProjectService {
  constructor(private http: HttpClient) {}

  public query() {
    const [params] = splayParams();
    const url = "/api/v4/projects";
    return this.http.get(url, { params });
  }

  public get(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}`;
    return this.http.get(url, { params }).pipe(
      map((data: any) => {
        const { project } = data;
        project.integrations = data.integrations;
        if (isEqual(project.integrations, {})) {
          // Fixes *ngIf="project.integrations".
          project.integrations = null;
        }
        return project;
      }),
    );
  }
}
